import { isValid, parse } from 'date-fns'
import { DATA_DATE_FORMAT, SHORT_DATA_DATE_FORMAT } from '~sharedConfig'

export const parseEventDate = (dateStr: string | null | undefined) => {
	if (!dateStr) return null
	let parsed = parse(dateStr, DATA_DATE_FORMAT, new Date())
	if (!isValid(parsed))
		parsed = parse(dateStr, SHORT_DATA_DATE_FORMAT, new Date())
	return parsed
}
